export default __webpack_public_path__ + "static/media/newFlag.36d0cbc5.svg";